import { render, staticRenderFns } from "./BaseMessage.vue?vue&type=template&id=905326e0&scoped=true"
import script from "./BaseMessage.vue?vue&type=script&lang=js"
export * from "./BaseMessage.vue?vue&type=script&lang=js"
import style0 from "./BaseMessage.vue?vue&type=style&index=0&id=905326e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905326e0",
  null
  
)

export default component.exports